import styled from "styled-components";

export const Row = styled.div<{ $background?: string }>`
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  min-height: 64px;
  padding: 0 var(--spacing-md, 12px);
  background: ${({ $background }) => $background || "transparent"};

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-gray-100, #e2e3e5);
  }
`;

export const AccentBar = styled.span<{ $color: string }>`
  position: absolute;
  left: 0;
  top: 16px;
  bottom: 16px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: ${({ $color }) => $color};
`;

export const Position = styled.span`
  width: 20px;
  flex-shrink: 0;
  text-align: right;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-subtle, #7d7e84);
`;

export const Thumbnail = styled.div`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: var(--radius-md, 8px);
  overflow: hidden;
  background: var(--color-gray-100, #e2e3e5);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const TitleBlock = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span<{ $muted?: boolean }>`
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ $muted }) =>
    $muted ? "var(--color-subtle, #7d7e84)" : "var(--color-gray-950, #19191b)"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Subtitle = styled.span`
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--color-subtle, #7d7e84);
`;

export const Duration = styled.span`
  flex-shrink: 0;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--color-foreground, #404145);
  font-variant-numeric: tabular-nums;
`;

export const StatusSlot = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* Fixed-width slot (reserved on both columns, even when empty) so the
     duration column lines up across rows regardless of a status label. */
  width: 100px;
`;
